import { useMemo } from "react"
import classNames from "classnames"
import { FieldLabel } from "@/components/ui/field"
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"

function minutesToParts(total) {
  return { hours: Math.floor(total / 60), minutes: total % 60 }
}

function partsToMinutes(h, m) {
  return h * 60 + m
}

export function WorkingHoursSelect({ value, onChange, label, name, invalid, disabled }) {
  const isBlank = value == null

  const { hours, minutes } = isBlank ? { hours: 0, minutes: 0 } : minutesToParts(value)

  const hourOptions = useMemo(() => {
    const opts = []
    for (let i = 0; i < 24; i++) {
      const h = String(i).padStart(2, "0")
      opts.push({ label: h, value: h })
    }
    return opts
  }, [])

  const minuteOptions = useMemo(() => {
    return ["00", "15", "30", "45"].map((m) => ({ label: m, value: m }))
  }, [])

  const hourValue = isBlank ? "" : String(hours).padStart(2, "0")
  const minuteValue = isBlank ? "" : String(minutes).padStart(2, "0")

  return (
    <div className={classNames("flex flex-col gap-3", { "opacity-50 pointer-events-none": disabled })}>
      {label && <FieldLabel>{label}</FieldLabel>}
      <div className="flex gap-1 items-center">
        <Select value={hourValue} onValueChange={(h) => onChange(partsToMinutes(Number(h), minutes))}>
          <SelectTrigger className="bg-white w-auto" aria-invalid={invalid || undefined}>
            <SelectValue placeholder="--" />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              {hourOptions.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
        :
        <Select value={minuteValue} onValueChange={(m) => onChange(partsToMinutes(hours, Number(m)))}>
          <SelectTrigger className="bg-white w-auto" aria-invalid={invalid || undefined}>
            <SelectValue placeholder="--" />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              {minuteOptions.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
      {name && <input type="hidden" name={name} value={value ?? ""} />}
    </div>
  )
}
